function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

export default function() {
  return this.each(raise);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-selection/src/selection/raise.js
// module id = NduY
// module chunks = 0